import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Container,
  Paper,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "../../components/navbar/Navbar";
import { colors } from "../../configs";
import Passenger from "../../models/Passenger";
import SliceCard from "./SliceCard";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import GROUP from "../../assets/images/group.png";
import cphones from "../../data/phonescode";
import { Divider, NativeSelect, Select, TextInput } from "@mantine/core";
import createShareGroopOrder from "../../queries/createShareGroopOrder";
import createDuffelOrder from "../../queries/createDuffelOrder";

const StyledButton = styled(Button)({
  backgroundColor: colors.main,
  color: "#FFFFFF",
  borderRadius: "12px",
  zIndex: 0,
  padding: "10px 30px",
});
const StyledVisaButton = styled(Button)({
  borderRadius: "5px",
  zIndex: 0,
  padding: "10px 30px",
});
const BoldText = styled(Typography)({
  color: "#000000",
  borderRadius: "11px",
  fontWeight: "400",
  margin: 0,
  padding: 0,
});
const LightText = styled(Typography)({
  color: "gray",
  fontSize: "11px",
  fontWeight: "100",
});
const LabelText = styled(Typography)({
  color: "#000000",
  fontSize: "11px",
  fontWeight: "300",
  margin: 0,
  padding: 0,
});
const StyledTexFiled = styled(TextField)({
  border: "0.5px solid #f2f2f2",
  borderRadius: "12px",
  flex: 1,
  margin: 0,
  padding: 0,
});
const CustomPaper = styled(Box)({
  padding: "25px",
  //  margin: "15px",
  borderRadius: "12px",
  backgroundColor: "#FFFFFF",
  boxShadow: "0 0px 1px rgba(0,0,0, 0.2), 0 1px 1px 0 rgba(0,0,0,0.2)",
});
const Resume = () => {
  let location = useLocation();

  const [passengers, setPassengers] = useState<Passenger[]>(
    location?.state?.passengers
  );
  const [koalas, setKoalas] = useState<any[]>(location?.state?.koalas);
  const [offers, setOffers] = useState<any[]>(location?.state?.offers);
  const [customer, setCustomer] = useState<any>(location?.state?.customer);

  const [bagsCost, setBagsCost] = useState<any>(location?.state?.bagsCost);
  const [flightsCost, setFlightsCost] = useState<any>(
    location?.state?.flightsCost
  );
  const [koalasCost, setKoalasCost] = useState<any>(location?.state?.koalaCost);
  const [seatsCost, setSeatsCost] = useState<any>(location?.state?.seatsCost);
  const [totalCoast, setTotalCost] = useState<any>(location?.state?.totalCoast);

  const [taxAmounts, setTaxAmounts] = useState<number>(0);
  const [baseAmounts, setBaseAmounts] = useState<number>(0);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [serviceFees, setServiceFees] = useState<number>(0);

  useEffect(() => {
    let bsA = 0;
    let txA = 0;
    let ttA = 0;
    let svF = 0;
    console.log("PASSED DATA IN RESUME: ", location?.state);

    offers.map((offer) => {
      bsA += parseFloat(offer.base_amount);
      txA += parseFloat(offer.tax_amount);
      ttA += parseFloat(offer.total_amount);
    });
    setBaseAmounts(bsA);
    setTaxAmounts(parseFloat(txA.toFixed(2)));
    svF = parseFloat(((12 * (ttA + txA)) / 100).toFixed(2));
    setServiceFees(parseFloat(svF.toFixed(2)));
    setTotalAmount(parseFloat((ttA + svF).toFixed(2)));
  }, [location]);

  const formatNameSticker = (fan: string, fin: string): string => {
    const fanSgle: string = fan.split(" ")[0];
    const finSingle: string = fin.split(" ")[0];
    const sticker: string = `${fanSgle.charAt(0)}${finSingle.charAt(0)}`;
    return sticker;
  };

  const returnPassType = (type: string, idx: number) => {
    const newType = type.split("_")[0];
    return idx + 1 + " " + newType.toUpperCase();
  };

  const goToPayment = () => {
    const payUrl = "https://teksapay.web.app";
    const redUrl = "https://teksa-5d07b.web.app";
    const data = buildCreateDuffelOrderQuery();

    console.log("====================================");
    console.log("THE DUFFEL BUILDED DATA :", data);
    console.log("====================================");
    createDuffelOrder(data)
      .then((response) => response.json())
      .then((data) => {
        console.log("DUFFEL ORDER RETURN: ", data);
        //  let customer = passengers.filter((pass) => pass.isClient === true)[0];

        createShareGroopOrder()
          .then((response) => response.json())
          .then((dataShareG) => {
            console.log("Payment order List: ", dataShareG);
            const bodyP = {
              amount: parseFloat(data.data.total_amount) * 100,
              trackId: data.data.booking_reference,
              //  ux: uxVal,
              currency: dataShareG.data.currency,
              successUrl: `${redUrl}/payment_confirmation`,
              failUrl: `${redUrl}/payment_confirmation`,
              cancelUrl: `${redUrl}/payment_confirmation`,
              redirectUrl: `${redUrl}/payment_confirmation`,
              notifyUrl: `${redUrl}/payment_confirmation?trackId=${data.data.booking_reference}`,
              orderId: dataShareG.data.id,
              email: passengers[0].email,
              firstName: passengers[0].given_name,
              lastName: passengers[0].family_name,
              items: [
                {
                  trackId: data.data.id,
                  name: data.data.booking_reference,
                  description: data.data.owner.name,
                  amount: parseFloat(data.data.total_amount) * 100,
                  quantity: 1,
                },
              ],
            };
            window.location.href = `${payUrl}/?order=${JSON.stringify(bodyP)}`;
          })
          .catch((err) => {
            console.log("Yen err", err);
          });
      })
      .catch((err) => {
        console.log("Yen Duffel create order err", err);
      });
  };
  const buildCreateDuffelOrderQuery = (): any => {
    const offersId: string[] = [];
    const payments: any[] = [];

    offers.map((offer, idx) => {
      offersId.push(offer.id);
      payments.push({
        type: "balance",
        currency: "EUR",
        amount: parseFloat(offer.total_amount),
      });
    });

    const tempPass = passengers;

    tempPass.map((pass, idx) => {
      pass.phone_number = "+32467660114";
      tempPass[idx] = pass;
    });

    console.log("====================================");
    console.warn("NEW PASSENGERS LIST: ", tempPass);
    console.log("====================================");

    setPassengers(tempPass);

    const data = {
      selected_offers: [offersId[0]],
      payments: [payments[0]],
      passengers: passengers,
      // type: "hold",
    };

    return data;
  };
  const phoneFiled = (
    <TextInput
      type="tel"
      placeholder="1000"
      styles={{
        input: {
          fontWeight: 500,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          width: "100px",
        },
      }}
    />
  );

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f2f2f2",
        }}>
        <Box
          sx={{
            minHeight: "250px",
            backgroundColor: "#eeeeee",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            alignContent: "center",
            padding: "10px 30px",
            backgroundImage: `url(${GROUP})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}>
          <Typography
            variant="h4"
            component="span"
            sx={{
              color: colors.main,
              flex: 1,
              fontWeight: "bold",
            }}>
            <pre>Teksa Corp.</pre>
          </Typography>
          <Navbar />
        </Box>
        {/* main container*/}
        <Container>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
            }}>
            {/* left contents container */}
            <Box
              sx={{
                flex: 3,
                display: "flex",
                flexDirection: "column",
                gap: 5,
              }}>
              {/* customer details container  */}
              <CustomPaper
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: 3,
                }}>
                <h4>Contact Details</h4>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 3,
                  }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 1,
                    }}>
                    <NativeSelect
                      data={cphones}
                      rightSection={phoneFiled}
                      rightSectionWidth={92}
                      style={{
                        width: "200px",
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}>
                    <Typography variant="body1" component="code">
                      Country Code
                    </Typography>
                    <Autocomplete
                      id="country-select"
                      sx={{ flex: 1 }}
                      options={cphones}
                      autoHighlight
                      getOptionLabel={(option: any) => option.phone}
                      value={null}
                      onChange={(event: any, newValue: any | null) => {
                        //  setSelectedCountry(newValue);
                        console.log("Choosen trips: ", newValue);
                      }}
                      renderOption={(props: any, option: any) => (
                        <Box
                          component="li"
                          sx={{
                            "& > img": {
                              mr: 1,
                              flexShrink: 0,
                              fontSize: "12px",
                              fontWeight: "100",
                            },
                          }}
                          {...props}>
                          <img
                            loading="lazy"
                            width="15"
                            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                            alt=""
                          />
                          +{option.phone}
                        </Box>
                      )}
                      renderInput={(params: any) => (
                        <TextField
                          {...params}
                          //  label="Votre pays de résidence"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-password", // disable autocomplete and autofill
                          }}
                        />
                      )}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}>
                    <Typography variant="body1" component="code">
                      Enter phone number
                    </Typography>
                    <StyledTexFiled id="phone" placeholder="07.." />
                  </Box>
                </Box>
              </CustomPaper>
              {/* flights(slices) details container  */}
              <CustomPaper
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}>
                {offers.map((offer: any, ofIdx) => (
                  <div key={ofIdx}>
                    <SliceCard offer={offer} />
                    {ofIdx !== offers.length - 1 && (
                      <Divider orientation="horizontal" />
                    )}
                  </div>
                ))}
              </CustomPaper>
              {/* Travel credit container  */}
              <Box>
                <h3>Travel Credits </h3>
                <CustomPaper
                  sx={{
                    maringTop: "15px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}>
                  <h4>
                    Do you wish to use your currently available credit (‪€60‬)?
                  </h4>
                  <Checkbox />
                </CustomPaper>
              </Box>

              {/* Promo code container  */}
              <Box>
                <h3>Promo Code</h3>
                <CustomPaper
                  sx={{
                    marginTop: "15px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}>
                  <h4
                    style={{
                      marginBottom: "5px",
                    }}>
                    Do you have a gift card or promo code ?
                  </h4>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 1,
                    }}>
                    <StyledTexFiled id="promoCode" variant="filled" />
                    <StyledButton
                      id="submitCodeBtn"
                      variant="contained"
                      onChange={() => null}>
                      Apply
                    </StyledButton>
                  </Box>
                </CustomPaper>
              </Box>
              {/* Visa needed block  */}
              <Box>
                <h3>E-visa</h3>
                <Paper
                  sx={{
                    marginTop: "15px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    padding: "5px 5px",
                    backgroundColor: "lightgray",
                  }}>
                  <h1
                    style={{
                      margin: "25px",
                    }}>
                    Find the right visa, apply in seconds and travel safely
                  </h1>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "#ffffff",
                      borderRadius: "5px",
                      padding: "15px",
                      gap: 1,
                    }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        gap: 1,
                      }}>
                      <BoldText variant="body1">Your passport</BoldText>
                      <BoldText variant="body1">
                        <LocationOnIcon />
                        Belgium(BEL)
                      </BoldText>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        gap: 1,
                      }}>
                      <BoldText variant="body1">Traveling to</BoldText>
                      <BoldText variant="body1">Kenya</BoldText>
                    </Box>
                    <Box>
                      <StyledVisaButton
                        id="submitVisaBtn"
                        variant="contained"
                        onChange={() => null}
                        sx={{
                          backgroundColor: "lightgray",
                          color: "#000000",
                        }}>
                        Do i need visa?
                      </StyledVisaButton>
                    </Box>
                  </Box>
                </Paper>
              </Box>
              {/* Go to payment button */}
              <Box
                sx={{
                  margin: "10px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}>
                <StyledButton
                  id="submitCodeBtn"
                  variant="contained"
                  onClick={() => goToPayment()}>
                  Go to payment
                </StyledButton>
              </Box>
            </Box>
            {/* right contents container */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                borderRadius: "12px",
                backgroundColor: "#ffffff",
                marginTop: "15%",
                marginLeft: "20px",
                height: "100%",
              }}>
              <CustomPaper
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  minWidth: "300px",
                  gap: 1,
                  marginBottom: "20px",
                }}>
                <BoldText variant="body1">Price Details</BoldText>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}>
                  <LightText variant="body1">
                    {passengers.length}x Passenger
                  </LightText>
                  <LabelText variant="body1">EUR {baseAmounts}</LabelText>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}>
                  <LightText variant="body1">Tax and fee</LightText>
                  <LabelText variant="body1">EUR {taxAmounts}</LabelText>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}>
                  <LightText variant="body1">Service free</LightText>
                  <LabelText variant="body1">EUR {serviceFees}</LabelText>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    backgroundColor: "#878CFF",
                    padding: "3px",
                    borderRadius: "5px",
                  }}>
                  <LightText
                    variant="body1"
                    sx={{
                      color: "#000000",
                    }}>
                    Total
                  </LightText>
                  <LabelText variant="body1">EUR{totalAmount}</LabelText>
                </Box>
                <Divider orientation="horizontal" />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}>
                  <BoldText variant="body1">
                    Passengers
                    {/* 
                    <LabelText
                      variant="body1"
                      sx={{
                        fontSize: "11px",
                        color: "#777E90",
                      }}>
                      1x adult 2 children
                    </LabelText>
                    */}
                  </BoldText>
                  <LabelText
                    variant="body1"
                    sx={{
                      color: "#F7926A",
                    }}>
                    Update
                  </LabelText>
                </Box>
                {passengers.map((pass, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 0,
                    }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-evenly",
                        alignItems: "center",
                        gap: 1,
                      }}>
                      <LightText
                        variant="body1"
                        style={{
                          minWidth: "60px",
                        }}>
                        {returnPassType(pass.type, idx)}
                      </LightText>
                      <Divider mx={0} orientation="vertical" style={{}} />

                      <LabelText
                        variant="body1"
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "5px",
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          backgroundColor: "#8B9FC3",
                        }}>
                        {formatNameSticker(pass.family_name, pass.given_name)}
                      </LabelText>
                    </Box>

                    <LabelText variant="body1">{`${pass.family_name} ${pass.given_name}`}</LabelText>
                  </Box>
                ))}
              </CustomPaper>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  minWidth: "300px",
                  padding: "15px",
                  gap: 1,
                }}>
                <Divider orientation="horizontal" />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}>
                  <BoldText variant="body1">Check-in baggage</BoldText>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}>
                  <LightText variant="body1">Depature</LightText>
                  <LightText variant="body1">3 bags ( 120g total)</LightText>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}>
                  <LightText variant="body1">Return</LightText>
                  <LightText variant="body1">3 bags ( 120g total)</LightText>
                </Box>
                <Divider orientation="horizontal" />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}>
                  <span>Services</span>
                </Box>
                <Divider variant="dashed" />
                <BoldText variant="body1">Insurances</BoldText>
                {passengers.map((pass, pIdx) => (
                  <Box
                    key={pIdx}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}>
                    <LabelText
                      variant="body1"
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "5px",
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        backgroundColor: "#8B9FC3",
                      }}>
                      {formatNameSticker(pass.family_name, pass.given_name)}
                    </LabelText>
                    {pass.koala.length > 0 ? (
                      <>
                        {pass.koala.map((koala, kIdx) => (
                          <Box
                            key={kIdx}
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}>
                            <LightText variant="body1">
                              - {koala.bundle.bundle}
                            </LightText>
                            <LabelText variant="body1">
                              {
                                //koala.bundle.price.currency
                                "€"
                              }
                              {koala.bundle.price.amount}
                            </LabelText>
                          </Box>
                        ))}
                      </>
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}>
                        <LightText variant="body1">Basic insurance.</LightText>
                        <LabelText variant="body1">Free</LabelText>
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Resume;
